import { Chart as ChartJS, defaults } from 'chart.js';
defaults.font.family = 'Nunito Sans', 'Nunito', 'Tahoma', 'Helvetica', 'Arial', 'sans-serif';

export { ChartJS };
